import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SideButtons } from '../../../interfaces';

@Component({
  selector: 'phoenix-secondary-side-buttons',
  templateUrl: './secondary-side-buttons.component.html',
  standalone: false,
})
export class SecondarySideButtonsComponent {
  @Input() buttons: SideButtons[] = [];

  @Output() buttonClicked = new EventEmitter<{
    id: string;
    action?: () => void;
  }>();

  onButtonClick(buttonId: string, action: (() => void) | undefined) {
    action && action(); // Executes the function passed as a parameter
    this.buttonClicked.emit({ id: buttonId, action });
  }
}
